import moment from "moment";
import { Vue } from "vue-class-component";
import { camelCase } from "lodash";
import { useStore } from "../store";
import HomepageService from "../service/HomepageService";


// You can declare mixins as the same style as components.
export default class UtilityOptions extends Vue {

    protected store = useStore();

    formatDate(value) {
        let d = "";
        if (value) {
            d = moment(value).format("DD-MM-YYYY");
        }
        return d;
    }
    
    formatMonthDate(value) {
        let d = "";
        if (value) {
            d = moment(value).format("MMM-YY");
        }
        return d;
    }

    get userPermission() {
        const p = JSON.parse(this.store.getters.gerUserPermissions);
        return p;
    }

    get userRole() {
        const p = JSON.parse(this.store.getters.getUserRole);
        return p;
    }

    getDayName(date) {
        let d = "";

        if (date != "") {
            d = moment(date).format("ddd");
        }

        return d;
    }

    formatTime(value) {
        let d = "";
        if (value) {
            d = moment(value, "HH:mm").format("hh:mm A");
        }
        return d;
    }

    formatAmount(value) {
        value = Number(value);
        return value.toFixed(2);
    }

    camelizeKeys = obj => {
        if (Array.isArray(obj)) {
            return obj.map(v => this.camelizeKeys(v));
        } else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce(
                (result, key) => ({
                    ...result,
                    [camelCase(key)]: this.camelizeKeys(obj[key])
                }),
                {}
            );
        }
        return obj;
    };

    can(permission) {
        const pL = this.userPermission;
        const f = pL.filter(e => e.name == permission);

        let res = false;

        if (f.length > 0) {
            res = true;
        }

        return res;
    }

    convertToFull(t) {
        let n = "";

        if (t == "REF") {
            n = "Receive Funds";
        } else if (t == "DPT") {
            n = "Bank Deposit";
        } else if (t == "EXP") {
            n = "Bank Expense";
        } else if (t == "FTR") {
            n = "Funds Transfer";
        } else if (t == "CHQ") {
            n = "Cheque";
        } else if (t == "INE") {
            n = "Sales Invoice";
        } else if (t == "RFD") {
            n = "Sales Refund";
        } else if (t == "TRN") {
            n = "Stock Transfer";
        } else if (t == "PUR") {
            n = "Stock Purchase";
        } else if (t == "RPU") {
            n = "Purchase Stock Return";
        } else if (t == "SLS") {
            n = "Sales Receipt";
        } else if (t == "INV") {
            n = "Invoice Receipt";
        } else if (t == "RFR") {
            n = "Refund Receipt";
        } else if (t == "CRV") {
            n = "Credit Voucher";
        } else if (t == "DBV") {
            n = "Debit Voucher";
        } else if (t == "JRV") {
            n = "Journal Voucher";
        } else if (t == "EXV") {
            n = "Expense Voucher";
        } else if (t == "OPB") {
            n = "User Opening balance";
        }

        return n;
    }

    formatDateTime(date) {
        return moment(date).format("DD-MM-YYYY hh:mm A");
    }

    printReceiptUtil(elementId = 'printableArea', title = 'Report') {
        const printContents = document.getElementById(elementId)?.innerHTML;

        if (printContents) {
            const newWindow = window.open('', '_blank');
            if (newWindow) {
            newWindow.document.write(`
                <html>
                <head>
                    <title>${title}</title>
                    <style>
                    body { font-family: Arial, sans-serif; font-size: 13px; margin: 20px; }
                    h4, h5, p { text-align: center; margin: 4px 0; }
                    table { width: 100%; border-collapse: collapse; margin-top: 12px; }
                    th, td { border: 1px solid #ccc; padding: 6px 10px; text-align: left; }
                    @media print {
                        body { margin: 10px; }
                    }
                    </style>
                </head>
                <body onload="window.print();">
                    ${printContents}
                </body>
                </html>
            `);
            newWindow.document.close();
            newWindow.focus();
            setTimeout(() => { newWindow.close(); }, 1500);
            }
        }
    }

    convertNineDNicToTwelve(nic){

        // Check if the input is a valid 9-digit string
        if (nic.length !== 10) {
            return nic;
        } 

        // Add '19' to the start of the NIC
        let modifiedNIC = '19' + nic;

        // Add '0' to the 6th digit (index 5)
        modifiedNIC = modifiedNIC.slice(0, 5) + '0' + modifiedNIC.slice(5);

        // Remove the last character
        modifiedNIC = modifiedNIC.slice(0, -1);

        return modifiedNIC;
    }

    validateNic(nic){
        nic = nic.trim();
        const today = new Date();
        const currentYear = today.getFullYear();

        const modifiedNic = this.convertNineDNicToTwelve(nic);
        // year validation
        if(modifiedNic.slice(0, 4) > currentYear){
            return false;
        }

        // 12 digit formatted NIC validation
        const rex = /^(19[0-9]{2}|20[0-9]{2})((00[1-9]|0[1-9][0-9]|[12][0-9]{2}|365)|(500|[5-8][0-9]{2}|865))\d{5}$/;
        const validTwelveNic = rex.test(modifiedNic);

        if(nic.length == 10){
            // 10 digit vaidation
            const validateTen = /^([0-9]{9})([V,v,X,x]{1})$/;
            const validNicWithLastChar = validateTen.test(nic);

            return (validNicWithLastChar && validTwelveNic);
        }
        return validTwelveNic;
    }
/*
    formatPhoneNumber(phone){
        // get and trim phone number
        // possible Phone number types 
        // 712xxxxxx : 9
        // 0112xxxxxx : 10
        // 0717xxxxxx : 10
        // 9471xxxxxxx : 11
        // +94717xxxxxx : 12
        var modifiedPhone = phone.trim();
        if(modifiedPhone.length == 9){
            // ok and add 94
            modifiedPhone = '94' + modifiedPhone;
        } else if(modifiedPhone.length == 10){
            // Get last 9 digits and add 94
            modifiedPhone = '94' + modifiedPhone.slice(-9);
        } else if(modifiedPhone.length == 11){
            // should be ok
        } else if(modifiedPhone.length == 12){
            // remove first char + and will fix this issue scenario Numeric Validation
            modifiedPhone = modifiedPhone.slice(-11);
        } else {
            modifiedPhone = '';
        }

        return modifiedPhone;
    }
    */

    formatPhoneNumber(phone: string): string {
        let p = phone.trim().replace(/\s+/g, '');

        if (/^\+94(\d{9})$/.test(p)) {
            // +94XXXXXXXXX -> 94XXXXXXXXX
            return '94' + p.slice(3);
        }
        if (/^94(\d{9})$/.test(p)) {
            // already 94XXXXXXXXX
            return p;
        }
        if (/^0(\d{9})$/.test(p)) {
            // 0XXXXXXXXX -> 94XXXXXXXXX
            return '94' + p.slice(1);
        }
        if (/^(\d{9})$/.test(p)) {
            // XXXXXXXXX (9 digits, no prefix) -> 94XXXXXXXXX
            return '94' + p;
        }
        return '';
    }

    validateMobileNumber(phone: string): boolean {
        const normalised = this.formatPhoneNumber(phone);
        if (!normalised) return false;

        const local = normalised.slice(2);
        const prefix2 = local.slice(0, 2); 
        const prefix3 = local.slice(0, 3); 

        const mobilePrefixes = ['70', '71', '72', '74', '75', '76', '77', '78'];
        if (mobilePrefixes.includes(prefix2)) return true;

        const landlinePrefixes = [
            '11', '31', '33', '34', '36', '38','81', '52', '54', '51', '66','91', '41', '47',
            '21', '23', '24','65', '26', '63', '67','37', '32','25', '27','55', '57','45', '35',
        ];
        if (landlinePrefixes.includes(prefix2)) return true;

        return false;

    }

    test(){
        alert('Test');
    }
}
